import RankIcon from "../rank-icon";

const RankUpdateToast = props => {

    const {title, message, icon} = props
    return (
        <div
            className="toast show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
        >
            <div className="toast-header">
                <strong className="me-auto">
                    <RankIcon icon={icon}/>
                    {title}
                </strong>
            </div>
            <div className="toast-body message small">
                {message}
            </div>
        </div>

    )

}

export default RankUpdateToast
